import { Component, Input } from '@angular/core';

import { venda } from '../../config-pedido-tipo-venda-indicador';

@Component({
    selector: 'sgt-config-pedido-tipo-venda-badge-venda',
    templateUrl: './config-pedido-tipo-venda-badge-venda.component.html',
    styleUrls: ['./config-pedido-tipo-venda-badge-venda.component.less']
})
export class ConfigPedidoTipoVendaBadgeVendaComponent {
    tipo = venda;

    /** Se o badge deve exibir o tipo de forma abreviada */
    @Input() isAbreviacao = false;
}
